import { Card, FormHelperText, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Spacer } from '@sparemin/blockhead';
import { withAttrs } from 'utils/react';

export const BudgetContainer = styled(
  withAttrs(Spacer, { orientation: 'vertical', space: '8px', align: 'center' }),
)`
  width: 100%;
`;

export const ErrorText = styled(withAttrs(FormHelperText, { error: true }))`
  text-align: center;
`;

export const CampaignCardsContainer = styled(Spacer)`
  width: 100%;
`;

export const CampaignCredits = styled(Card)`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border-radius: 8px;
  border-color: #bec8d2;
  background-color: #fafafa;
`;

export const CreditTitle = styled(Typography)`
  width: fit-content;
  padding: 4px 8px;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.supporting1.main};
`;

export const CreditDescription = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey[700]};
`;
